import { useEffect, useMemo, useState } from "react";
import { Table, Col, Tag } from "antd";
import dayjs from "../../../../utils/dayjs";
import { CURRENCY_SYMBOL } from "../helper";
import DownloadInvoice from "./DownloadInvoice";
import { parseError } from "../../../../utils/shared";
import httpClient from "../../../../api/httpClient";
import { useSearchParams } from "react-router-dom";

const TransactionTable = () => {
  const [searchParams] = useSearchParams();
  const tenant_id = searchParams.get("tenant_id");

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await httpClient.get(
          "paddle/subscription-transactions",
        );

        setTransactions(data);
      } catch (error) {
        parseError(error, true);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const columns = useMemo(
    () => [
      {
        title: "Billed At",
        dataIndex: "billed_at",
        key: "billed_at",
        render: (date) =>
          date ? dayjs(date).format("DD MMM YYYY, hh:mm A") : "-",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (status) => {
          const statusColors = {
            draft: "default",
            ready: "blue",
            billed: "orange",
            paid: "cyan",
            completed: "green",
          };

          return (
            <Tag
              className="uppercase-text"
              color={statusColors[status] || "default"}
            >
              {status}
            </Tag>
          );
        },
      },
      {
        title: "Amount",
        dataIndex: ["details", "totals", "grand_total"],
        key: "amount",
        render: (amount, data) => (
          <span style={{ fontWeight: 600 }}>
            {CURRENCY_SYMBOL[data.currency_code]}
            {(amount / 100).toFixed(2)}
          </span>
        ),
      },
      {
        title: "Billing Period",
        dataIndex: "billing_period",
        key: "billing_period",
        render: (period) => {
          if (!period) return "-";

          const startDate = dayjs(period.starts_at).isValid()
            ? dayjs(period.starts_at).format("DD MMM YYYY")
            : "-";

          const endDate = dayjs(period.ends_at).isValid()
            ? dayjs(period.ends_at).format("DD MMM YYYY")
            : "-";

          return `${startDate} - ${endDate}`;
        },
      },
      {
        title: "Action",
        key: "action",
        render: (_, record) => (
          <DownloadInvoice record={record} tenant_id={tenant_id} />
        ),
      },
    ],
    [tenant_id],
  );

  return (
    <Col xs={24} md={16} className="transaction-table">
      <Table
        columns={columns}
        dataSource={transactions}
        rowKey="id"
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} transactions`,
        }}
        scroll={{
          y: "calc(100dvh - 223px)",
          x: "max-content",
        }}
        sticky
        loading={loading}
        style={{
          height: "100%",
        }}
      />
    </Col>
  );
};

export default TransactionTable;
